module.exports = __webpack_public_path__ + "static/11-sinfang-1eb72c6fe6e8ecc61622040521a34907.jpg";